import {
  Button,
  IconText,
  Image,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import useAddYearlyRecap from "./useAddYearlyRecap";
import Select from "react-select";
import ColorPickerField from "../../../../utils/components/ColorPickerField";
import Style from "./addYearlyRecap.module.scss";

const AddYearlyRecap = ({
  refetch,
  yearlyRecapState,
  handleModal,
  setYearlyRecapState,
  recapBasicData,
}) => {
  const {
    formik,
    imageUploadState,
    imageRef,
    aliasImageRef,
    handleDelete,
    addHeading,
    getFieldError,
    handleImageChange,
  } = useAddYearlyRecap({
    refetch,
    yearlyRecapState,
    handleModal,
    setYearlyRecapState,
  });
  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Content Type
        </label>
        <Select
          id="content_type"
          name="content_type"
          placeholder={"Select"}
          className={`pro-input lg  ${
            getFieldError("content_type") && " error"
          }`}
          classNamePrefix="pro-input"
          options={recapBasicData?.type || []}
          getOptionLabel={(option) => option?.name}
          getOptionValue={(option) => option?.id}
          value={recapBasicData?.type?.find(
            (m) => m?.id === formik?.values?.content_type
          )}
          onBlur={formik.handleBlur("content_type")}
          onChange={(value) => {
            formik.setFieldValue("content_type", value?.id);
            formik.setFieldValue("dynamic_type", "");
            formik.setFieldValue("headings", [
              {
                heading: "",
                alias_heading: "",
                size: "",
                color: "#000000",
              },
            ]);
          }}
          menuPlacement="auto"
        />
        {getFieldError("content_type") && (
          <span className="error-text">{getFieldError("content_type")}</span>
        )}
      </div>
      <div className={Style.no_spinner}>
        <Input
          label={"Recap Position"}
          type="number"
          id="position"
          name="position"
          className={`pro-input lg ${getFieldError("position") && "error"}`}
          {...formik.getFieldProps("position")}
          error={getFieldError("position")}
          errorMessage={getFieldError("position")}
          onKeyDown={(e) => {
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
            ];
            if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
              e.preventDefault();
            }
          }}
        />
      </div>
      {formik?.values?.content_type?.toString() === "2" && (
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Dynamic type
          </label>
          <Select
            id="dynamic_type"
            name="dynamic_type"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("dynamic_type") && " error"
            }`}
            classNamePrefix="pro-input"
            options={recapBasicData?.dynamic_type || []}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.value}
            value={recapBasicData?.dynamic_type?.filter(
              (m) => m?.value === formik?.values?.dynamic_type
            )}
            onBlur={formik.handleBlur("dynamic_type")}
            onChange={(value) => {
              formik.setFieldValue("dynamic_type", value?.value);
              if (value?.value !== "loyality") {
                formik.setFieldValue("headings", [
                  {
                    heading: "",
                    alias_heading: "",
                    size: "",
                    color: "#000000",
                  },
                ]);
              }
            }}
            menuPlacement="auto"
          />
          {getFieldError("dynamic_type") && (
            <span className="error-text">{getFieldError("dynamic_type")}</span>
          )}
        </div>
      )}
      {!(
        formik?.values?.content_type?.toString() === "2" &&
        ["product", "store"].includes(formik?.values?.dynamic_type)
      ) &&
        formik?.values?.headings?.map((heading, index) => (
          <div className={`${Style.section_item}`}>
            {formik?.values?.headings?.length > 1 && (
              <span
                className={`material-symbols-outlined ${Style.handleDelete} x4`}
                onClick={() => handleDelete(index)}
              >
                close
              </span>
            )}
            <Input
              label={`Heading ${index + 1}`}
              type="text"
              id={`headings[${index}].heading`}
              name={`headings[${index}].heading`}
              className={`pro-input lg ${
                getFieldError(`headings[${index}].heading`) && " error"
              }`}
              {...formik.getFieldProps(`headings[${index}].heading`)}
              // onChange={(event) => capitalizeOnSpace(event, formik.setFieldValue)}
              error={getFieldError(`headings[${index}].heading`)}
              errorMessage={getFieldError(`headings[${index}].heading`)}
            />
            <div className="pro-rtl">
              <Input
                label={"(اسم العنوان)Heading "}
                type="text"
                id={`headings[${index}].alias_heading`}
                name={`headings[${index}].alias_heading`}
                className={`pro-input lg ${
                  getFieldError(`headings[${index}].alias_heading`) && " error"
                }`}
                {...formik.getFieldProps(`headings[${index}].alias_heading`)}
                error={getFieldError(`headings[${index}].alias_heading`)}
                errorMessage={getFieldError(`headings[${index}].alias_heading`)}
              />
            </div>
            <ColorPickerField
              label="Color"
              name={`headings[${index}].color`}
              formik={formik}
            />

            <div className="input-wrap pro-mb-4">
              <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
                Heading Size
              </label>
              <Select
                id={`headings[${index}].size`}
                name={`headings[${index}].size`}
                placeholder={"Select"}
                className={`pro-input lg  ${
                  getFieldError(`headings[${index}].size`) && " error"
                }`}
                classNamePrefix="pro-input"
                options={recapBasicData?.heading || []}
                getOptionLabel={(option) => option?.name}
                getOptionValue={(option) => option?.value}
                value={recapBasicData?.heading?.find(
                  (m) => m?.value === formik?.values?.headings?.[index]?.size
                )}
                onBlur={formik.handleBlur(`headings[${index}].size`)}
                onChange={(value) =>
                  formik.setFieldValue(`headings[${index}].size`, value?.value)
                }
                menuPlacement="auto"
              />
              {getFieldError(`headings[${index}].size`) && (
                <span className="error-text">
                  {getFieldError(`headings[${index}].size`)}
                </span>
              )}
            </div>
          </div>
        ))}
      {formik?.values?.content_type !== 2 && (
        <div className="pro-d-flex pro-justify-end pro-items-center">
          <button
            className={"pro-pnt pro-mt-3"}
            type="button"
            onClick={addHeading}
          >
            Add Heading
          </button>
        </div>
      )}
      {formik?.values?.content_type?.toString() === "1" && (
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Heading position
          </label>
          <Select
            id="heading_position"
            name="heading_position"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("heading_position") && " error"
            }`}
            classNamePrefix="pro-input"
            options={recapBasicData?.position || []}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            value={recapBasicData?.position?.filter(
              (m) => m?.id === formik?.values?.heading_position
            )}
            onBlur={formik.handleBlur("heading_position")}
            onChange={(value) =>
              formik.setFieldValue("heading_position", value?.id)
            }
            menuPlacement="auto"
          />
          {getFieldError("heading_position") && (
            <span className="error-text">
              {getFieldError("heading_position")}
            </span>
          )}
        </div>
      )}

      <div className="pro-check-box pro-py-2">
        <input
          type="checkbox"
          className="pro-check"
          id="is_button"
          name="pro-checkbox"
          checked={Boolean(formik.values?.is_button === 1) ?? false}
          onChange={(e) =>
            formik.setFieldValue(`is_button`, e?.target?.checked ? 1 : 2)
          }
        />
        <label htmlFor="default" className="pro-check-label">
          Show Action Button
        </label>
      </div>
      {formik.values?.is_button === 1 && (
        <>
          <ColorPickerField
            label="Button Color"
            name="button_color"
            formik={formik}
          />
          <Input
            label={`Button Text`}
            type="text"
            id={`button_text`}
            name={`button_text`}
            className={`pro-input lg ${
              getFieldError(`button_text`) && " error"
            }`}
            {...formik.getFieldProps(`button_text`)}
            // onChange={(event) => capitalizeOnSpace(event, formik.setFieldValue)}
            error={getFieldError(`button_text`)}
            errorMessage={getFieldError(`button_text`)}
          />
          <ColorPickerField
            label="Button Text Color"
            name="button_text_color"
            formik={formik}
          />
          <div className="pro-rtl">
            <Input
              label={"(نص الزر)Button Text "}
              type="text"
              id="alias_button_text"
              name="alias_button_text"
              className={`pro-input lg ${
                getFieldError("alias_button_text") && " error"
              }`}
              {...formik.getFieldProps("alias_button_text")}
              error={getFieldError("alias_button_text")}
              errorMessage={getFieldError("alias_button_text")}
            />
          </div>
        </>
      )}
      <div className="input-wrap pro-mb-4 ">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          Image
        </label>
        <div className="input-drag">
          <input
            type="file"
            ref={imageRef}
            accept=".jpeg,.jpg , .png "
            className={`pro-input ${
              formik?.errors?.image && formik?.touched?.image && " error"
            }`}
            id="image"
            onBlur={formik?.handleBlur("image")}
            onChange={(e) => handleImageChange(e, "image", imageRef)}
          />
          <span className="input-drag-box">
            <IconText
              title={
                imageUploadState?.imageLoading
                  ? "Uploading..."
                  : formik?.values?.image !== ""
                  ? formik?.values?.image?.split("/").pop()
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {formik?.touched?.image && formik?.errors?.image && (
            <span className="error-text">{formik?.errors?.image}</span>
          )}
        </div>
        <div className={`col-2 pro-my-2`}>
          <div className={``}>
            <Image
              width={100}
              height={100}
              src={yearlyRecapState?.imageFile ?? ""}
              alt={`image - 01`}
            />
          </div>
        </div>
      </div>
      <div className="input-wrap pro-mb-4 pro-rtl">
        <label htmlFor="" className={`pro-font-sm pro-mb-1 pro-fw-medium`}>
          ( صورة ) Image
        </label>
        <div className="input-drag">
          <input
            type="file"
            ref={aliasImageRef}
            accept=".jpeg,.jpg , .png "
            className={`pro-input ${
              formik?.errors?.alias_image &&
              formik?.touched?.alias_image &&
              " error"
            }`}
            id="alias_image"
            onBlur={formik?.handleBlur("alias_image")}
            onChange={(e) => handleImageChange(e, "alias_image", aliasImageRef)}
          />
          <span className="input-drag-box">
            <IconText
              title={
                imageUploadState?.imageAliasLoading
                  ? "...Uploading"
                  : formik?.values?.alias_image !== ""
                  ? formik?.values?.alias_image?.split("/").pop()
                  : `Drop files to attach or browse`
              }
            />
          </span>
          {formik?.touched?.alias_image && formik?.errors?.alias_image && (
            <span className="error-text">{formik?.errors?.alias_image}</span>
          )}
        </div>
        <div className={`col-2 pro-my-2`}>
          <div className={``}>
            <Image
              width={100}
              height={100}
              src={yearlyRecapState?.imageAliasFile ?? ""}
              alt={`image - 01`}
            />
          </div>
        </div>
      </div>
      <div className="pro-check-box pro-py-2">
        <input
          type="checkbox"
          className="pro-check"
          id="status"
          name="pro-checkbox"
          checked={Boolean(formik.values?.status === 1) ?? false}
          onChange={(e) =>
            formik.setFieldValue(`status`, e?.target?.checked ? 1 : 2)
          }
        />
        <label htmlFor="default" className="pro-check-label">
          Status
        </label>
      </div>
      <div
        className={`col-12 pro-d-flex pro-justify-end  offcanvas-footer-sticky-btn `}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleModal}>
          Cancel
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${
            formik?.isSubmitting ? "loading pro-pnt-none" : ""
          }`}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default AddYearlyRecap;
